<template>
  <!-- Main Content -->
  <div class="page-wrapper">
    <div class="container-fluid">
      <!-- Title -->
      <div class="row heading-bg">
        <div class="col-lg-3 col-md-4 col-sm-4 col-xs-12">
          <h5 class="txt-dark">Upload Groups</h5>
        </div>
        <!-- Breadcrumb -->
        <div class="col-lg-9 col-sm-8 col-md-8 col-xs-12">
          <ol class="breadcrumb">
            <li><router-link to="/">Dashboard</router-link></li>
            <li>Data Center</li>
            <li class="active">Upload Groups</li>
          </ol>
        </div>
        <!-- /Breadcrumb -->
      </div>
      <!-- /Title -->

      <!-- Row -->
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-default card-view">
            <div class="panel-wrapper collapse in">
              <div class="panel-body">
                &nbsp;&nbsp;
                <a
                  :href="`${mediaUrl}samples/group-sample-data.xlsx`"
                  target="_blank"
                >
                  [ Download Sample Excel ]
                </a>

                <input
                  type="file"
                  id="file"
                  name="file"
                  ref="file"
                  accept="application/ms-excel"
                  multiple
                />
                <br />
                <a href="javascript:void" @click="truncatePendingDocuments"
                  >Truncate List</a
                >
                <br /><br />
                <span style="color: red"> {{ message }} </span>
                <span v-if="isLoading"> Uploading...</span>

                <div class="form-footer" v-if="crudGroups.length == 0">
                  <button
                    class="btn btn-primary btn-block"
                    @click="handleFileUpload"
                  >
                    Upload file
                  </button>
                </div>

                <div class="form-footer" v-else>
                  <button
                    class="btn btn-success btn-block"
                    @click="processFile"
                  >
                    Process file
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Row -->

      <!-- Row -->
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-default card-view">
            <div class="panel-wrapper collapse in">
              <div class="panel-body">
                <div class="table-wrap">
                  <table class="table table-hover table-striped">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>NAME</th>
                        <th>EMAIL</th>
                        <th>PHONE</th>
                        <th>ADDRESS 1</th>
                        <th>ADDRESS 2</th>
                        <th>CITY</th>
                        <th>STATE</th>
                        <th>COUNTRY</th>
                        <th>PINCODE</th>
                        <th>GST IN NO</th>
                        <th>PAN NO</th>
                      </tr>
                    </thead>
                    <tbody>
                      <loading-table
                        :isLoading="isLoading"
                        cols="2"
                      ></loading-table>
                      <tr
                        v-for="(crudgroup, at) in crudGroups"
                        :key="`crudgroup${at}`"
                      >
                        <td>{{ serialNoStarting + at + 1 }}</td>
                        <td>{{ crudgroup.name }}</td>
                        <td>{{ crudgroup.email }}</td>
                        <td>{{ crudgroup.phone }}</td>
                        <td>{{ crudgroup.address_1 }}</td>
                        <td>{{ crudgroup.address_2 }}</td>
                        <td>{{ crudgroup.city }}</td>
                        <td>{{ crudgroup.state }}</td>
                        <td>{{ crudgroup.country }}</td>
                        <td>{{ crudgroup.pincode }}</td>
                        <td>{{ crudgroup.gstin_no }}</td>
                        <td>{{ crudgroup.pan_no }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Row -->
    </div>
  </div>
  <!-- /Main Content -->
</template>

<script type="text/javascript">
import axios from "axios";
export default {
  name: "uploadGroups",
  data() {
    return {
      crudGroups: [],
      message: "",
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData(page = 1) {
      this.isLoading = true;
      let crudGroups = await axios.get(`/crud_group`);
      this.crudGroups = crudGroups.data.data;
      // console.log(this.crudGroups);
      this.count = crudGroups.data.count;
      this.serialNoStarting = (page - 1) * this.rowsPerPage;
      this.isLoading = false;
    },
    async handleFileUpload() {
      this.isLoading = true;
      this.Groups = this.$refs.file.files[0];
      let formData = new FormData();
      formData.append("groupsData", this.Groups);
      await axios
        .post("upload_group", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.data) this.crudGroups = response.data.data;
          this.isLoading = false;
          alert("Uploaded Successfully");
        })
        .catch(function() {
          console.log("FAILURE!!");
        });
      this.isLoading = false;
    },
    async processFile() {
      try {
        this.isLoading = true;
        await axios.get("process_group");
        alert("Processed Successfully");
        await axios.get("truncate_groups");
        this.crudGroups = [];
        this.isLoading = false;
      } catch (e) {
        console.log(e);
      }
    },
    async truncatePendingDocuments() {
      await axios.get("truncate_groups");
      alert("Truncated Successfully");
      this.crudGroups = [];
    },
    async deleteDocument($id) {
      var r = confirm("Are you sure you want to delete the document!");
      if (r == true) {
        await axios.delete(`crude_group/${$id}`);
        this.crudGroups = this.crudGroups.filter((d) => d.id != $id);
      }
    },
  },
};
</script>
